import { ViewController } from '@estee/elc-service';
import { emit, events } from '@estee/elc-service-bus';

interface IEngravingData {
    skuId: string;
    skuBaseId?: number;
    size: string;
    price: string;
    name: string;
}

export class ProductEngravingViewController extends ViewController {
    public openEngraving = (engravingData: IEngravingData) => {
        emit(events.SKU_ENGRAVING_TRIGGERED, engravingData);
    };
}
